import React from 'react';
import { Link } from 'react-router-dom';

// import VideoModal from '../ModalVideo';
import './style.css';

const Hero = (props) => {
  return (
    <section className='hero hero-style-2'>
      <div className='hero-slider'>
        <div className='slide'>
          <div className='container'>
            <div className='row'>
              <div className='col col-lg-5 slide-caption'>
                <div className='slide-title'>
                  <h2>Our Vision</h2>
                </div>
                <div className='slide-subtitle'>
                  <p>
                    To Bring Life-changing Care to Orphaned and Vulnerable
                    Children in the East African Community.
                  </p>
                </div>
                <div className='btns'>
                  <Link to='/donate' className='theme-btn'>
                    Donate Now
                  </Link>
                  {/* TODO: RE-ENABLE IT ONCE SOURCE VIDEO UPLOADED */}
                  {/* <ul>
                    <li className='video-holder'>
                      <VideoModal />
                    </li>
                    <li className='video-text'>Watch Our Video</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
          <div className='right-vec'></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
